// src/polyfills/global.js
// AWS Cognito / buffer.js için global tanımı
if (typeof globalThis.global === "undefined") {
  globalThis.global = globalThis;
}
if (typeof globalThis.process === "undefined") {
  globalThis.process = { env: { DEBUG: undefined } };
}
if (typeof globalThis.Buffer === "undefined") {
  try {
    globalThis.Buffer = [];
  } catch {
    console.warn("Buffer polyfill oluşturulamadı.");
  }
}
